export const DAYS_IN_WEEK = 7

export const HOURS_IN_DAY = 24
export const HOURS_IN_WEEK = 7 * HOURS_IN_DAY

export const MINUTES_IN_HOUR = 60
export const MINUTES_IN_DAY = HOURS_IN_DAY * MINUTES_IN_HOUR
export const MINUTES_IN_WEEK = DAYS_IN_WEEK * MINUTES_IN_DAY

export const SECONDS_IN_MINUTE = 60
export const SECONDS_IN_HOUR = MINUTES_IN_HOUR * SECONDS_IN_MINUTE
export const SECONDS_IN_DAY = HOURS_IN_DAY * SECONDS_IN_HOUR
export const SECONDS_IN_WEEK = DAYS_IN_WEEK * SECONDS_IN_DAY

export const MILLISECONDS_IN_SECOND = 1000
export const MILLISECONDS_IN_MINUTE = SECONDS_IN_MINUTE * MILLISECONDS_IN_SECOND
export const MILLISECONDS_IN_HOUR = MINUTES_IN_HOUR * MILLISECONDS_IN_MINUTE
export const MILLISECONDS_IN_DAY = HOURS_IN_DAY * MILLISECONDS_IN_HOUR
export const MILLISECONDS_IN_WEEK = DAYS_IN_WEEK * MILLISECONDS_IN_DAY

export function millisecondsToSeconds(miliseconds: number, trunc = true): number {
  const result = miliseconds / MILLISECONDS_IN_SECOND

  return trunc ? Math.trunc(result) : result
}

export function millisecondsToMinutes(miliseconds: number, trunc = true): number {
  const result = miliseconds / MILLISECONDS_IN_MINUTE

  return trunc ? Math.trunc(result) : result
}

export function millisecondsToHours(miliseconds: number, trunc = true): number {
  const result = miliseconds / MILLISECONDS_IN_HOUR

  return trunc ? Math.trunc(result) : result
}

export function millisecondsToDays(miliseconds: number, trunc = true): number {
  const result = miliseconds / MILLISECONDS_IN_DAY

  return trunc ? Math.trunc(result) : result
}

export function millisecondsToWeeks(miliseconds: number, trunc = true): number {
  const result = miliseconds / MILLISECONDS_IN_WEEK

  return trunc ? Math.trunc(result) : result
}

export function secondsToMilliseconds(seconds: number): number {
  return seconds * MILLISECONDS_IN_SECOND
}

export function secondsToMinutes(seconds: number, trunc = true): number {
  const result = seconds / SECONDS_IN_MINUTE

  return trunc ? Math.trunc(result) : result
}

export function secondsToHours(seconds: number, trunc = true): number {
  const result = seconds / SECONDS_IN_HOUR

  return trunc ? Math.trunc(result) : result
}

export function secondsToDays(seconds: number, trunc = true): number {
  const result = seconds / SECONDS_IN_DAY

  return trunc ? Math.trunc(result) : result
}

export function secondsToWeeks(seconds: number, trunc = true): number {
  const result = seconds / SECONDS_IN_WEEK

  return trunc ? Math.trunc(result) : result
}

export function minutesToMilliseconds(minutes: number): number {
  return minutes * MILLISECONDS_IN_MINUTE
}

export function minutesToSeconds(minutes: number): number {
  return minutes * SECONDS_IN_MINUTE
}

export function minutesToHours(minutes: number, trunc = true): number {
  const result = minutes / MINUTES_IN_HOUR

  return trunc ? Math.trunc(result) : result
}

export function minutesToDays(minutes: number, trunc = true): number {
  const result = minutes / MINUTES_IN_DAY

  return trunc ? Math.trunc(result) : result
}

export function minutesToWeeks(minutes: number, trunc = true): number {
  const result = minutes / MINUTES_IN_WEEK

  return trunc ? Math.trunc(result) : result
}

export function hoursToMilliseconds(hours: number): number {
  return hours * MILLISECONDS_IN_HOUR
}

export function hoursToSeconds(hours: number): number {
  return hours * SECONDS_IN_HOUR
}

export function hoursToMinutes(hours: number): number {
  return hours * MINUTES_IN_HOUR
}

export function hoursToDays(hours: number, trunc = true): number {
  const result = hours / HOURS_IN_DAY

  return trunc ? Math.trunc(result) : result
}

export function hoursToWeek(hours: number, trunc = true): number {
  const result = hours / HOURS_IN_WEEK

  return trunc ? Math.trunc(result) : result
}

export function daysToMilliseconds(days: number): number {
  return days * MILLISECONDS_IN_DAY
}

export function daysToSeconds(days: number): number {
  return days * SECONDS_IN_DAY
}

export function daysToMinutes(days: number): number {
  return days * MINUTES_IN_DAY
}

export function daysToHours(days: number): number {
  return days * HOURS_IN_DAY
}

export function daysToWeek(days: number, trunc = true): number {
  const result = days / DAYS_IN_WEEK

  return trunc ? Math.trunc(result) : result
}

export function weeksToMilliseconds(weeks: number): number {
  return weeks * MILLISECONDS_IN_WEEK
}

export function weeksToSeconds(weeks: number): number {
  return weeks * SECONDS_IN_WEEK
}

export function weeksToMinutes(weeks: number): number {
  return weeks * MINUTES_IN_WEEK
}

export function weeksToHours(weeks: number): number {
  return weeks * HOURS_IN_WEEK
}

export function weeksToDays(weeks: number): number {
  return weeks * DAYS_IN_WEEK
}
